module.exports = __webpack_public_path__ + "img/DT80T.9f70342f.jpg";